/**
 * Occupancy as a 0-to-1 fraction (the UI multiplies by 100 for the
 * percent display).
 *
 *   Occupancy = Equivalency / Licensed Equivalency
 *
 * Both sides are weighted-equivalent counts (see `computeEquivalency`
 * and `computeLicensedEquivalency` for definitions). Returns `null`
 * when the licensed equivalency is 0 — an undefined ratio rather
 * than `Infinity`, so the cell renders "—" instead of nonsense.
 *
 * Over-capacity (> 1.0) is allowed without clamping: UW wants to see
 * the raw number, and a > 100 % occupancy is a real signal that a
 * facility is over its bed count.
 */
export function computeOccupancy(equivalency: number, licensedEquivalency: number): number | null {
    if (licensedEquivalency === 0) return null;
    return equivalency / licensedEquivalency;
}
